import merge from 'lodash/merge';
import type { PartialDeep } from 'type-fest';

import type { StepState } from '../../types';

type PartialPetition = PartialDeep<StepState['petition']>;
type PartialMetadata = PartialDeep<StepState['metadata']>;

type Action =
	| { type: 'NEXT'; payload?: PartialPetition }
	| { type: 'BACK' }
	| { type: 'SKIP' }
	| { type: 'UPDATE_PETITION'; payload: PartialPetition }
	| { type: 'UPDATE_METADATA'; payload: PartialMetadata };

// eslint-disable-next-line max-lines-per-function
export function stepReducer(state: StepState, action: Action): StepState {
	const { petition, metadata } = state;

	switch (action.type) {
		case 'NEXT': {
			const updatedPetition = merge({}, petition, action.payload);
			return {
				...state,
				petition: updatedPetition,
				metadata: {
					...metadata,
					currentStepIndex: metadata.currentStepIndex + 1,
					// set navigation direction. used when skipping steps to know which direction to navigate
					direction: 'forward' as const,
				},
			};
		}
		case 'BACK': {
			return {
				...state,
				metadata: {
					...metadata,
					currentStepIndex: metadata.currentStepIndex - 1,
					// set navigation direction. used when skipping steps to know which direction to navigate
					direction: 'back' as const,
				},
			};
		}
		case 'SKIP': {
			return merge({}, state, {
				metadata: {
					currentStepIndex: metadata.currentStepIndex + 1,
					// set navigation direction. used when skipping steps to know which direction to navigate
					direction: 'forward' as const,
				},
			});
		}
		case 'UPDATE_PETITION': {
			const updatedPetition = merge({}, petition, action.payload);
			return {
				...state,
				petition: updatedPetition,
			};
		}
		case 'UPDATE_METADATA': {
			const updatedMetadata = merge({}, metadata, action.payload);

			return {
				...state,
				metadata: updatedMetadata,
			};
		}
		default: {
			return state;
		}
	}
}
